import React, { useEffect } from "react";
import { Linking } from "react-native";
import { useApplication } from "../contexts/ApplicationContext";

export const FreeplayMessageInjector = (): JSX.Element => {
    const { appDispatch } = useApplication();

    useEffect(() => {
        window.sendFreePlayMessage = (msg: string) => {
            switch (msg) {
                case "showHome":
                    appDispatch({ type: "showHome" });
                    break;
                case "showLeaderboard":
                    appDispatch({ type: "showLeaderboard" });
                    break;
                case "showPicks":
                    appDispatch({ type: "showMyPicks" });
                    break;
                case "showPrivacyPolicy":
                case "showTerms":
                case "showSupport":
                    Linking.openURL("http://google.com");
                    break;
            }
        };

        return () => {
            window.sendFreePlayMessage = void 0;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <></>;
};
